import AbstractManageable from "./abstract-manageable";
import Account from "./account";
import Chapter from "./chapter";
import User from "./user";

export default class Instruction extends AbstractManageable {
	/**
	 * 
	 * @param {Number} id 
	 * @param {String} name 
	 * @param {Account[]} accounts 
	 * @param {Class[]} classes 
	 * @param {Chapter[]} chapters 
	 * @param {User} creator 
	 * @param {Date} createdAt 
	 * @param {User} updater 
	 * @param {Date} updatedAt 
	 */
	constructor(
			id, 
			name, 
			accounts, 
			classes, 
			chapters, 
			creator, 
			createdAt, 
			updater, 
			updatedAt) {
		super(creator, createdAt, updater, updatedAt);
		this.accounts = accounts;
		this.chapters = chapters;
		this.classes = classes;
		this.id = id;
		this.name = name;
	}

	static createFromJson = (json) => {
		if (!json) return null;

		const id = json.id;
		const name = json.name;
		const accounts = json.accounts && json.accounts.map(j => Account.createFromJson(j));
		const classes = json.classes && json.classes.map(j => Class.createFromJson(j));
		const chapters = json.chapters && json.chapters.map(j => Chapter.createFromJson(j));
		const creator = User.createFromJson(json.creator);
		const createdAt = new Date(json.createdAt);
		const updater = User.createFromJson(json.updater);
		const updatedAt = new Date(json.updatedAt);

		return new Instruction(
			id, 
			name, 
			accounts, 
			classes, 
			chapters, 
			creator, 
			createdAt, 
			updater, 
			updatedAt)
	}
}


// WEBPACK FOOTER //
// ./src/model/instruction.js